import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Box as u } from "@mui/material";
import { LinearProgress as B } from "./index88.mjs";
import { progressBarClasses as i } from "./constants4.mjs";
import { mergeClassNames as P } from "./mergeClassNames.mjs";
import { isDefined as p } from "./types3.mjs";
import { ProgressBarDescription as h } from "./index134.mjs";
import { ProgressBarValue as w } from "./index133.mjs";
import { ProgressBarContainer as C } from "./index131.mjs";
import { ProgressBarLabel as b } from "./index132.mjs";
const q = ({
  testId: n,
  size: f = "medium",
  position: r = "top",
  variant: x = "determinate",
  icon: s,
  label: o,
  value: l,
  valueLabel: t,
  description: m,
  className: g,
  sx: d,
  ...c
}) => /* @__PURE__ */ a(
  C,
  {
    "data-testid": n,
    ...c,
    sx: { position: "relative", flexGrow: 1, ...d },
    className: P([i.root, g]),
    children: [
      o && /* @__PURE__ */ e(
        b,
        {
          label: o,
          sx: {
            mr: r === "top" ? 6 : 0,
            overflow: "hidden"
          }
        }
      ),
      /* @__PURE__ */ a(
        u,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            gap: r === "center" ? "20px" : "unset"
          },
          className: i.wrapper,
          children: [
            /* @__PURE__ */ e(
              B,
              {
                variant: x,
                value: l,
                size: f,
                sx: { flexGrow: 1 }
              }
            ),
            t && /* @__PURE__ */ e(
              w,
              {
                valueLabel: t,
                sx: {
                  py: 0.25,
                  position: r !== "center" ? "absolute" : "initial",
                  right: 0,
                  top: r === "top" ? "-2px" : "unset",
                  bottom: r === "bottom" ? "0" : "unset"
                }
              }
            )
          ]
        }
      ),
      (p(m) || p(s)) && /* @__PURE__ */ e(
        h,
        {
          icon: s,
          sx: { justifyContent: r === "top" ? "space-between" : "unset" },
          children: m
        }
      )
    ]
  }
);
export {
  q as ProgressBar,
  C as ProgressBarContainer,
  h as ProgressBarDescription,
  b as ProgressBarLabel,
  w as ProgressBarValue
};
//# sourceMappingURL=index89.mjs.map
